import { DASHBOARD_ACCESS } from "@/helpers/permissionsConstant";

export default [
  {
    header: 'CMS Content',
  },
  {
    title: 'CMS Pages',
    icon: 'FileTextIcon',
    gate: DASHBOARD_ACCESS, // Gate add kora hoyeche
    children: [
      {
        title: 'About Us',
        route: { name: 'admin-settings-pages', params: { slug: 'about_us_content' } },
        gate: DASHBOARD_ACCESS,
      },
      {
        title: 'Privacy Policy',
        route: { name: 'admin-settings-pages', params: { slug: 'privacy_policy_content' } },
        gate: DASHBOARD_ACCESS,
      },
      {
        title: 'Terms & Conditions',
        route: { name: 'admin-settings-pages', params: { slug: 'terms_condition_content' } },
        gate: DASHBOARD_ACCESS,
      },
      {
        title: 'Return & Exchange',
        route: { name: 'admin-settings-pages', params: { slug: 'return_exchange_content' } },
        gate: DASHBOARD_ACCESS,
      },
      {
        title: 'Contact Us',
        route: { name: 'admin-settings-pages', params: { slug: 'contact_us_content' } },
        gate: DASHBOARD_ACCESS,
      },
    ],
  },
]